<template>
    <div class="header">
        <div class="header-log">
            <img src = "static/image/hengan_logo@3x.png" style="height: 30px;"/>
        </div>
    </div>
</template>

<script>
// 引入api模块
export default {
//        组件名称
  name: 'Header',
  //        初始化数据
  data () {
    return { }
  },
  //        方法集
  methods: {

  },
  //        进入加载
  created () {
  }
}
</script>
<style scoped>
  .header{
    background-color: #F5F6FA;
    height: 80px
  }
.header-log{
  float: left;
  margin-top: 20px;
  padding-left:20px;
}
body{
  margin:0
}
</style>



// WEBPACK FOOTER //
// src/layout/ExamHeader.vue